import React, { FC } from "react";
import { Card, Col, Divider, Row } from "antd";

import useHttpGet from "../../../hooks/useHttpGet";
import { IResultResponse } from "../../../models/response/result.model";
import { APIRoutes } from "../../../http";
import { IChangeLogs } from "../../../models/change-logs.model";

const ChangeLogs: FC = () => {
  const { fetchedData, loading } = useHttpGet<IResultResponse<IChangeLogs[]>>(
    `${APIRoutes.CHANGE_LOGS}`,
    {
      defaultValue: { result: [] as IChangeLogs[] },
    }
  );

  return (
    <Row justify="center" align="top">
      <Col xs={24} sm={24} md={20}>
        <Card
          className="mb-1 custom-card-1"
          title={
            <div className="d-flex align-items-center">
              <span className="fs-36">Change Log</span>
            </div>
          }
          loading={loading}
        >
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            {fetchedData.result?.map((el: IChangeLogs, index: number) => (
              <Col xs={24} sm={24} md={24}>
                <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                  <Col xs={24} sm={24} md={8}>
                    <span className="fs-22">{el.title}</span>
                  </Col>
                  <Col xs={24} sm={24} md={16}>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: el?.content,
                      }}
                      className="pl-1 pt-0_5"
                    />
                  </Col>
                </Row>

                {index < fetchedData.result.length && <Divider />}
              </Col>
            ))}
          </Row>
        </Card>
      </Col>
    </Row>
  );
};

export default ChangeLogs;
